import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=7bd8db39&scoped=true&"
import script from "./PlanDetail.vue?vue&type=script&lang=ts&"
export * from "./PlanDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=7bd8db39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8db39",
  null
  
)

export default component.exports